import { ListItemText } from "@material-ui/core";
import { FilterSelect, FilterMenuItem } from "../styles";

const ALL = "ALL";
const ACTIVE = "ACTIVE";
const INACTIVE = "INACTIVE";

const OPTIONS = [
  { key: ALL, name: "Усі" },
  { key: ACTIVE, name: "Активні" },
  { key: INACTIVE, name: "Неактивні" },
];

interface StatusFilterProps {
  label: string;
  selectedValue: boolean | null;
  onChange: (value: boolean | null) => void;
}

const toKey = (value: boolean | null) =>
  value === null ? ALL : value ? ACTIVE : INACTIVE;

const fromKey = (key: string): boolean | null =>
  key === ALL ? null : key === ACTIVE;

export const StatusFilter = ({
  label,
  selectedValue,
  onChange,
}: StatusFilterProps) => {
  return (
    <FilterSelect
      displayEmpty
      value={toKey(selectedValue)}
      renderValue={() => label}
      variant="outlined"
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => onChange(fromKey(e.target.value as string))}
    >
      {OPTIONS.map(({ key, name }) => (
        <FilterMenuItem key={key} value={key}>
          <ListItemText primary={name} />
        </FilterMenuItem>
      ))}
    </FilterSelect>
  );
};
